import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { MetricBox } from './utils';

const GRADE_COLORS = {
  A: '#4caf50',
  B: '#8bc34a',
  C: '#ff9800',
  D: '#f44336',
  F: '#9c27b0',
};

function getScoreColor(score) {
  if (score >= 75) return '#4caf50';
  if (score >= 50) return '#ff9800';
  return '#f44336';
}

const tooltips = {
  overall: 'Overall domain quality score (0-100). Grades: A (90-100), B (75-89), C (60-74), D (40-59), F (0-39). Higher is better.',
  advertising_quality: 'Ads.txt compliance, ad density, network diversity, and bidder coverage. Higher = better ad setup.',
  site_reputation: 'Tranco ranking, SSP audit status, DNS health, SSL, domain age, and PageSpeed performance. Higher = more reputable.',
  mfa_detection: 'Made-for-Advertising risk: content-to-ad ratio, pagination abuse, paid traffic. Higher = lower MFA risk.',
  traffic_quality: 'Historical IVT rates, fill rate, geographic anomalies, and revenue outliers. Higher = cleaner traffic.',
  supply_path: 'Supply chain complexity, reseller ratios, and intermediary counts. Higher = healthier supply path.',
  brand_safety: 'Sensitive keywords, redirect domains, malware indicators. Higher = safer content.',
};

export default function DomainMetricBoxes({ scan }) {
  if (!scan) return null;

  const cs = scan.category_scores;
  const overallScore = scan.overall_score;
  const overallGrade = scan.overall_grade;

  if (!cs || overallScore === undefined) return null;

  const categories = [
    { key: 'advertising_quality', label: 'Ad Quality' },
    { key: 'site_reputation', label: 'Reputation' },
    { key: 'mfa_detection', label: 'MFA Risk' },
    { key: 'brand_safety', label: 'Brand Safety' },
    { key: 'traffic_quality', label: 'Traffic' },
    { key: 'supply_path', label: 'Supply Path' },
  ];

  return (
    <Box style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      <MetricBox label="Overall Score" tooltip={tooltips.overall} color={GRADE_COLORS[overallGrade] || '#999'}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
          <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '18px', lineHeight: 1.2 }}>
            {overallGrade}
          </Typography>
          <Typography style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
            {overallScore}
          </Typography>
        </Box>
      </MetricBox>
      {categories.map(({ key, label }) => {
        const cat = cs[key];
        if (!cat) return null;
        return (
          <MetricBox key={key} label={label} tooltip={tooltips[key]} color={getScoreColor(cat.score)}>
            <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
              {cat.score}
            </Typography>
          </MetricBox>
        );
      })}
    </Box>
  );
}

export { GRADE_COLORS, getScoreColor };
